// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3iU-_","inputWrap":"Table_inputWrap__3JYlO","col":"Table_col__1_1wG","bmiTooltip":"Table_bmiTooltip__1499F"};